import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechnicalNameSelectComponent } from './technical-name-select.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [TechnicalNameSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [TechnicalNameSelectComponent],
})
export class TechnicalNameModule {}
